export default (node => {
  var blockTitle = node.querySelector('[data-cms-title="Title"]');
  var Data = JSON.parse(node.getAttribute('data-blocks'));
  return {
    blockTitle: blockTitle ? blockTitle.innerHTML : null,
    Data: Data ? Data : null
  };
});